export default __webpack_public_path__ + "static/media/droughtPopupImageCroped.f81579de.png";